import { MyInput } from "../../../../components-config/StyledComponents";

const StyledInput = MyInput

export default StyledInput;
